import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigateStart } from "../state";

export const CloseButton = ({ className = "text-white hover:text-dark hover:bg-white" }) => {
  const close = useNavigateStart();
  return (
    <button
      onClick={close}
      className={`${className} ml-auto absolute top-2 right-2 p-1 rounded-full`}
    >
      <FontAwesomeIcon icon={faXmark} className="w-3 h-3" />
    </button>
  );
};
